import BigNumber from "bignumber.js";
import { CDF } from "./cdf";

export class CdfLookup {
  cdf(x: BigNumber) {

    const ux = x.abs();
    let x1: BigNumber;
    let x2: BigNumber;
    if (ux.gt(new BigNumber('4000000000000000000'))) {
      x2 = new BigNumber('4000000000000000000');
      x1 = new BigNumber('3990000000000000000');
    } else {
      x1 = ux.minus(ux.mod(new BigNumber('10000000000000000')));
      x2 = x1.plus(new BigNumber('10000000000000000'));
    }

    let v: BigNumber;
    if (x1.eq(ux)) {
      v = new BigNumber(CDF[ux.toString(10)]);
    } else {
      const v1 = new BigNumber(CDF[x1.toString(10)]);
      const v2 = new BigNumber(CDF[x2.toString(10)]);
      v = v1.plus(v2.minus(v1).times(ux.minus(x1)).divEvm(x2.minus(x1)));
    }
    v = v.gt(new BigNumber('1000000000000000000')) ? new BigNumber('1000000000000000000') : v;
    return x.lt(0) ? new BigNumber('1000000000000000000').minus(v) : v;
  }
}
